const WALL_TYPE = {
  left: 0,
  right: 1,
};

export default WALL_TYPE;
